/**
 * Created by hejikun on 2017/10/30 0030.
 */

const requireComponent = require.context('./modules', true, /\.js$/)

export default {
  install: function (_Vue) {
    requireComponent.keys().forEach((fileName) => {
      const componentConfig = requireComponent(fileName)

      const componentName = fileName.replace(/^\.\//, '').replace(/\.\w+$/, '')
      const content = componentConfig.default || componentConfig
      _Vue.filter(componentName, content)
      _Vue.prototype.utils[componentName] = content
    })
  }
}
